// extracted by mini-css-extract-plugin
module.exports = {"root":"root--CSlTN","image":"image--k-wmV","row":"row--9a3C8","rowTitle":"rowTitle--3tW-O","rowImage":"rowImage--Wpo2c","description":"description--NT30s"};